import { DataGrid } from "components/DataGrid/DataGrid";
import { Toast } from "components/ToastShow/ToastAlert";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { useEffect, useState } from "react";
import { Response } from "types/types";
import { downloadCSV, getGridSetting, getPageSize, trans } from "utils/helpers";
import { deletePersonAsync, getPersonRealList } from "../api/api";
import { PersonRealForm } from "./components/PersonRealForm/PersonRealForm";
import "./style.scss";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ToolbarInTab } from "components/ToolbarInTab/ToolbarInTab";
import { MessageType } from "types/enum";

interface PersonRealListProp{
  curentTab?:string;
}
export const PersonRealList = ({    curentTab}:PersonRealListProp) => {

  let [responsePerson, setResponsePerson] = useState<Response | any>();
  let personRealList = [];
  let HeadPersonReal: string[] = [];
  let Total_records, pages;
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [person, setPerson] = useState();
  const [messageType, setMessageType] = useState<any>("info");
  const [idPersonReal, setIdPersonReal] = useState<any>(null);
  const [showForm, setShowForm] = useState<any>(null);
  const [forceUpdate, setForceUpdate] = useState(true); // integer state
  const [mode, setMode] = useState<any>()
  const [selectedList, setSelectedList] = useState<any>()
  const [search, setSearch] = useState(null);
  const [filterAndSort, setFilterAndSort] = useState<any>(null);

//  let filterlist =""
  

const clickToolbarCallback = (clickedButtonName: string) => {
  console.log("clickedButtonName" ,clickedButtonName)
  switch (clickedButtonName.toLowerCase()) {
    case "reference":alert("call api reference with Id :");break;
    case "view": if (idPersonReal){setMode("view"); setShowForm(true)}; break;
    case "edit": if(idPersonReal){setMode("edit"); setShowForm(true)};break;
    case "print":alert("print ");break;
    case "excel":downloadCSV(responsePerson?.Data ,1 ,trans("PersonRealList"));break;
    case "remove": if (idPersonReal)handleDeletePersonReal(idPersonReal); break;
    case "refresh":setForceUpdate(!forceUpdate);break;
    case "create":
      setMode("create")
      setShowForm(true)
      // setIdPersonReal(null);
      break;
  }
};



const Searchhandleer = (str) => {
  setPageNum(1);
  if(str =="" ){
      setSearch(null)
  }else{
      setSearch(str)
  }
}












  const personIdCallback = (obj , index) => {
    if(sessionStorage.getItem("changingforms")+""=="true"){
      // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
      //   sessionStorage.setItem("changingforms" , "false");
      //   setIdPersonReal(obj.Id);
      //   localStorage.removeItem("unSavedData");
      //   });
      Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
        sessionStorage.setItem("changingforms" , "false");
        setIdPersonReal(obj.Id);
       ///// localStorage.removeItem("unSavedData");
         const newData=   JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.PersonReal
            if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
        });
    }else{
      setIdPersonReal(obj.Id);
    }
  }

  const handleEditPersonReal = (id: any) => {
    setMode("edit")
    setIdPersonReal(id)
    setShowForm(true)
  }

  async function deletePerson(id){
    try {
         const response = await  deletePersonAsync(id)
         getPersonRealListAsync();
    } catch (err: any) {
     
    }
  
  }
  
  const handleDeletePersonReal = (id: string) => {
    // Toast(trans("msg_deleteconfirm"), "warning" , "alert" , ()=>{deletePerson(id)}) 
    Toast(trans("msg_deleteconfirm"),MessageType.confirmDelete , ()=>{deletePerson(id)}) 

    setIdPersonReal(id)    


  }
  const handleViewPersonReal = (id: string) => {
    setMode("view")
    setIdPersonReal(id)    
    setShowForm(true)
  }

  const handlechangePageSize = (e: any) => {
    setPageSize(e.currentTarget.value);
    setPageNum(1);
    getPageSize("PersonReal" ,e.currentTarget.value  )
    getPersonRealListAsync(e.currentTarget.value)
  };

  const handleGoPage = (value) => {
    if (value) {
      if (value < 1 || value > pages) {}
      else setPageNum(value);
    } else {
 
    }
  };
  const HandleNextPage = () => {
    if (pageNum < pages) setPageNum((pageNum) => { return +pageNum + 1 });
  };
  const HandlePrevPage = () => {
    
    if (pageNum > 1) setPageNum((pageNum) => { return +pageNum - 1 });
  };

  const handleAddPerson =(ans)=>{
    setPerson(ans);
  }
 

  

  async function getPersonRealListAsync(size=pageSize) {
    setLoading(false)
    let pageSizeChangedByUser = getPageSize("PersonReal" )
    setPageSize(pageSizeChangedByUser)
    try {
      const response = await getPersonRealList(pageNum, pageSizeChangedByUser ?pageSizeChangedByUser : size, filterAndSort?.OrderFormat?.join(","), filterAndSort?.Filterlist,search);
      setResponsePerson(response.Data)
          } catch (error) {
      setMessageType("error")
    }
    setLoading(true);
  }

  useEffect(() => {
    let settings = getGridSetting("PersonReal")


      setFilterAndSort({ Filterlist: settings[0], OrderFormat: settings[1] })


    if(sessionStorage.getItem("changingforms")=="true"||localStorage.getItem("unSavedData")!=null){
      let forms = JSON.parse(localStorage.getItem("unSavedData")+"")??{}
      
      if(forms?.PersonReal){

        //  Toast(trans("AreYouSureToRecoverUnsavedData"),"warning","alertWithoutClose",()=>{
        //    forms["PersonReal"]?.Id ? setMode("edit"):setMode("create")
        //    sessionStorage.setItem("changingforms" , "true");
        //      setIdPersonReal(forms["PersonReal"]?.Id)
        //      setShowForm(true)
        //  },"","",()=>{
        //      sessionStorage.setItem("changingforms" , "false");
        //      localStorage.removeItem("unSavedData");
        //  })
        Toast(trans("AreYouSureToRecoverUnsavedData"),MessageType.confirm,()=>{
          forms?.PersonReal?.Id ? setMode("edit"):setMode("create")
          sessionStorage.setItem("changingforms" , "true");
            setIdPersonReal(forms?.PersonReal?.Id)
            setShowForm(true)
        },"",()=>{
            sessionStorage.setItem("changingforms" , "false");
            /////localStorage.removeItem("unSavedData");
            const newData=   JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.PersonReal
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }

        })
        

      }
       
    }
  }, []);

  useEffect(() => {
    if(curentTab == "PersonReal"){
      if(filterAndSort!=null){
      getPersonRealListAsync();
      setIdPersonReal(null)
    }}
  }, [pageNum, person ,forceUpdate,filterAndSort,search,curentTab]);

  if (responsePerson && responsePerson?.Data.length > 0) {
    HeadPersonReal = Object.keys(responsePerson.Data[0]);
    // HeadPersonReal.splice(1, 0, "operations"); // در اینجا به آپریشنز را به عنوان ستون دوم قرار می دهیم
    personRealList = responsePerson.Data;
    Total_records = responsePerson.TotalRecords;
  }
  pages = Total_records > pageSize ? Math.ceil(Total_records / pageSize) : 1;


  return (
    <>
    { (curentTab == "PersonReal")&&
    <>
      {showForm  ?
             <ModalForm modalHeight={90} mode={mode} onHide={()=>{setShowForm(false)}} show={showForm} modalProfileKey={"PersonRealForm"}    title={trans("PersonRealForm") } >

               {!idPersonReal ? <PersonRealForm
                 mode={mode}
                 handleCancelForm={(e)=>{setShowForm(false)}}
                 handleAddPerson={handleAddPerson}
               />
               :
               <PersonRealForm
                 mode={mode}
                 handleCancelForm={(e)=>{setShowForm(false)}}
                 idPersonReal={idPersonReal}
                 handleAddPerson={handleAddPerson}
               />
      }


             </ModalForm> 

        // (personContext.id ? <PersonRealForm id={personContext.id} /> : <PersonRealForm />)idPersonReal
        : null}
       <ToolbarInTab excel={false} handleSearch={Searchhandleer} id={idPersonReal} create={true} remove={true} edit={true} search={true} handlePrint={(e)=>{console.log("e0ee--" ,e )}} handleClickToolbar={(e)=>{console.log("ee",e ) ; clickToolbarCallback(e) } } />
      <div style={{overflowY: "auto", 
          height: "63vh",
           scrollbarWidth: "thin"}} className=" col-lg-12 mt-1">
        <div className={`person-card`}>
          <div className="person-card__body ">
            {loading ? (<>
              {responsePerson && responsePerson?.Data.length>0 ? //{responsePerson != responsePersonPre ? <> //uncomment when using DataGridAg => prevent seconde render
                <DataGrid
               
                handlefiltering={(str:any) => {str.Filterlist != undefined  ? setFilterAndSort(str) : setFilterAndSort({...filterAndSort, Filterlist:str})}}
                filterStr={filterAndSort?.Filterlist}
                orderFormatList={filterAndSort?.OrderFormat}
                orderFormat={(order) => { setFilterAndSort({ ...filterAndSort, OrderFormat: order }) }}
                  DoubleClick={(e)=>{setIdPersonReal(e.Id) ;clickToolbarCallback("view")}}
         
                  selectList={setSelectedList}
                  parentName={"PersonReal"}
                  theadData={HeadPersonReal}
                  minCellWidth={80}
                  tbodyData={personRealList}
                  selectedRowObjectCallback={personIdCallback}
                  handleEdit={handleEditPersonReal}
                  handleDelete={handleDeletePersonReal}
                  handleView={handleViewPersonReal}
                  totalRecords={Total_records}
                  pageNum={pageNum}
                  pageSize={pageSize}
                  HandleNextPage={HandleNextPage}
                  HandlePrevPage={HandlePrevPage}
                  handlechangePageSize={handlechangePageSize}
                  first={() => setPageNum(pages)}
                  end={() => setPageNum(1)}
                  handleGoPage={handleGoPage}
                  multiSelect={false}
                />
                :<Message message={"NoDataForPreview"} type={messageType} />
              }
            </>) :
              <Loading />}
          </div>
        </div>
      </div>
    </>
    }
    </>
  );
};
